const selectorKeys = [
  // Pages view
  "pages_reorderPagesButton",
  "pages_collapsedPage", // append page given name
  "pages_deletePageButton",
  "pages_addPageButton",
  "pages_editDesignButton",

  // Reorder pages view
  "reorderPages_backButton",
  "reorderPages_pageDragHandle", // append page given name
  "reorderPages_pageVisibilityToggle", // append page given name

  // Sections view
  "sections_editPageSettingsButton",
  "sections_addPrimaryButton",
  "sections_addElementButton",
  "sections_collapsedSection", // append section type
  "sections_collapsedPrimaryText",
  "sections_collapsedEditButton",
  "sections_collapsedField", // append field name
  "sections_addToPageButton",
  "sections_reorderSectionsLink",

  // Reorder sections view
  "reorderSections_backButton",
  "reorderSections_sectionDragHandle", // append section type

  // Page settings view
  "pageSettings_cancelButton",
  "pageSettings_pageNameInput",
  "pageSettings_rsvpSubHeading",
  "pageSettings_textAlignmentSelector", // append left/center/right
  "pageSettings_imageSizeSlider",
  "pageSettings_pageDividerSelector",
  "pageSettings_pageShowMapSelector",
  "pageSettings_saveButton",

  // Edit section view
  "editSection_editField", // append field name
  "editSection_addPhotoButton",
  "editSection_galleryItemDragHandle",
  "editSection_changePhotoButton",
  "editSection_removePhotoButton",
  "editSection_editPhotoButton",
  "editSection_deleteButton",
  "editSection_cancelButton",
  "editSection_saveButton",

  // Media manager view
  "media_uploadButton",
  "media_manageLibraryLink",
  "media_libraryItem",
  "media_cancelButton",
  "media_selectButton",
  "mediaDelete_backButton",
  "mediaDelete_cancelButton",
  "mediaDelete_libraryItem",
  "mediaDelete_deleteButton",

  // Add section view
  "addSection_backButton",
  "addSection_addPrimaryButton",
  "addSection_addElement", // append section type

  // Website display
  "website_displayPageTitle", // append page given name
  "website_displaySection", // append section type

  // Edit design view
  "editDesign_backToPagesButton",
  "editDesign_changeDesignLink",
  "editDesign_layoutThumbnail", // append layout key (l1, l2, l3, l4)
  "editDesign_multiPageOption",
  "editDesign_singlePageOption",
  "editDesign_originalArtworkAlert",
  "editDesign_displayStylePicker",

  // Edit fonts view
  "editFonts_editFontsButton",
  "editFonts_fontDropdown",
  "editFonts_fontOption",
  "editFonts_fontScaleSlider",
  "editFonts_fontSection", // append section name
  "editFonts_lineSpacingSlider",
  "editFonts_resetToDefaultButton",
  "editFonts_undoButton",

  // Edit colors view
  "editColors_createCustomColorSwatch",
  "editColors_customColorThemeSwatch", // append theme index
  "editColors_designColorwaySwatch", // append colorway index
  "editColors_editColorsButton",
  "editColors_colorSection", // append category name (background, text, etc.)
  "editColors_hexField", // append category name
  "editColors_colorPicker", // append category name
  "editColors_createCustomColorPaletteButton",
  "editColors_deleteCustomColorPaletteButton",
  "editColors_defaultColorThemesSection",
  "editColors_customColorThemesSection",

  // Website preview
  "preview_viewSiteStyles",
  "preview_previewMySite",
  "preview_viewSiteMobile",
  "preview_viewSiteDesktop",

  // Guest Management - Main Components
  "guest_dashboardWrapper",
  "guest_dashboard",
  "oi_guestDashboard",

  // Guest Management - Wedding Website Components
  "guest_rsvpTable",
  "guest_summaryTable",
  "guest_eventFilterHeader",
  "guest_eventFilterOpenButton",
  "guest_filterDrawer",
  "guest_filterDrawerApply",
  "guest_filterDrawer_clearAll",
  "guest_filterDrawer_title",
  "guest_guestDetailsDrawer",
  "guest_guestDetailsDrawer_cancel",
  "guest_guestDetailsDrawer_firstName",
  "guest_guestDetailsDrawer_lastName",
  "guest_guestDetailsDrawer_save",
  "guest_addGuestsButton",
  "guest_addGuests_optionIndividual",
  "guest_addGuests_optionSpreadsheet",
  "guest_weddingInvite_partySizeStepper",
  "guest_weddingInvite_toggleGuestNames",
  "guest_weddingInvite_saveGuest",
  "guest_rsvpTable_partySizeEdit",
  "guest_summarySearch",
  "guest_summarySearchInput",
  "guest_emptyState",
  "guest_emptyState_uploadSpreadsheet",
  "guest_emptyState_addFromPastGuestLists",
  "guest_emptyState_addFromAddressBook",
  "guest_emptyState_addressCollectionCta",
  "guest_emptyState_old",
  "guest_bulkActionsSelect",
  "guest_emailPopover_emailGuests",
  "guest_emailPopover_rsvpReminder",
  "guest_emailModal_emailSentTitle",
  "guest_emailModal_emailSentClose",

  // RSVP - Public Guest Flow (Wedding Website)
  "rsvp_searchNameInput",
  "rsvp_findRsvpButton",
  "rsvp_searchModal_nameInput",
  "rsvp_searchModal_findButton",
  "rsvp_searchModal_selectResult",
  "rsvp_attendingPicker",
  "rsvp_backButton",
  "rsvp_nextButton",
  "rsvp_submitButton",
  "rsvp_cookieError", // shared with Online Invitation — same semantic element

  // RSVP - Public Guest Flow (Online Invitation)
  "oi_rsvp_adultStepper",
  "oi_rsvp_childStepper",
  "oi_rsvp_partySizeStepper",
  "oi_rsvp_noteToHost",
  "oi_rsvp_changeResponseButton",

  // Guest Management - Online Invitation Components
  "oi_dashboardHeader",
  "oi_shareLinkModal",
  "oi_dashboardEmptyState",
  "oi_dashboardFilledState",
  "oi_guestDetailsDrawer",
  "oi_guestDetailsDrawer_deleteGuest",
  "oi_guestDetailsDrawer_title",
  "oi_previewAndSendModal",
  "oi_guestTable",
  "oi_search",
  "oi_actionCard",
  "oi_addGuests_optionIndividual",
  "oi_addGuests_optionList",
  "oi_addGuests_optionSpreadsheet",
  "oi_addGuestsButton",
  "oi_inlineEditableContactName",
  "oi_inlineEditableContactInfo",
  "oi_inlineEditablePartySize",
  "oi_inlineEditableRSVPStatus",
  "oi_actionCard_addNewContact",
  "oi_actionCard_uploadSpreadsheet",
  "oi_actionCard_addFromAddressBook",
  "oi_actionCard_addFromPastEvent",
  "oi_button_saveGuest",
  "oi_button_saveAndAddAnotherGuest",
  "oi_button_previewAndSend",
  "oi_button_shareLink",
  "oi_button_shareLinkMobile",
  "oi_guestDrawer_householdName",
  "oi_guestDrawer_phoneOrEmail",
  "oi_guestTable_openRowDrawer",
  "oi_rsvpTabCount_0",
  "oi_rsvpTabCount_1",
  "oi_rsvpTabCount_2",
  "oi_rsvpTabCount_3",
  "oi_rsvpTabCount_4",
  "oi_rsvpTotalsSnapshot",
  "oi_searchInput",
  "oi_shareLinkModal_body",
  "oi_shareLinkModal_cancel",
  "oi_shareLinkModal_copy",

  // OI Messages Dashboard - RSVP Notes
  "oi_rsvpNote",
  "oi_rsvpNote_guestName",
  "oi_rsvpNote_noteText",
  "oi_rsvpNote_status",

  // OI Send Update flow
  "oi_button_sendUpdate",
  "oi_button_sendUpdateMobile",
  "oi_newUpdateButton",
  "oi_newUpdateButton_template_0",
  "oi_newUpdateButton_template_1",
  "oi_newUpdateButton_template_2",
  "oi_newUpdateButton_template_3",
  "oi_sendUpdateModal_checkbox_attending",
  "oi_sendUpdateModal_checkbox_notAttending",
  "oi_sendUpdateModal_checkbox_noReply",
  "oi_sendUpdateModal_checkbox_maybe",
  "oi_sendUpdateModal_fromInput",
  "oi_sendUpdateModal_subjectInput",
  "oi_sendUpdateModal_messageInput",
  "oi_sendUpdateModal_sendButton",
  "oi_sendUpdateModal_successMessage",
  "oi_sendUpdateModal_doneButton",

  // Event Form - Guest List Settings
  "eventForm_inviteOnlyToggle",
  "eventForm_adultChildRsvpsToggle",
  "eventForm_allowMaybeRsvpToggle",

  // Settings - Guest Preferences
  "settings_downloadGuestList",
  "settings_guestPreferencesTitle",
  "settings_inviteOnlyToggle",
  "settings_adultChildRsvpsToggle",
  "settings_showGuestListToggle",
  "settings_showAttendingCheckbox",
  "settings_showNotAttendingCheckbox",
  "settings_showNotRepliedCheckbox",
  "settings_showMaybeCheckbox",

  // Stripe Registry - Creation Wizard
  "stripeRegistry_wizard_continueButton",
  "stripeRegistry_wizard_cancelButton",
  "stripeRegistry_wizard_typeSelector",

  // Stripe Registry - Edit Form
  "stripeRegistry_edit_amountTypeOption", // append: any, fixed
  "stripeRegistry_edit_hideGoalCheckbox",
  "stripeRegistry_edit_displayQuickOptionsToggle",

  // Stripe Registry - Manage View
  "stripeRegistry_manage_closeButton",
  "stripeRegistry_manage_visibilityToggle",
  "stripeRegistry_manage_editDetailsButton",
  "stripeRegistry_manage_viewGiftsButton",

  // Stripe Registry - Manage Preview
  "stripeRegistry_managePreview_fundedText",
  "stripeRegistry_managePreview_progressBar",

  // Stripe Registry - Collapsed
  "stripeRegistry_collapsed_progressBar",

  // Stripe Registry - Modals
  "stripeRegistry_receivedGiftsModal_cashOutSection",
  "stripeRegistry_receivedGiftsModal_dashboardSection",
  "stripeRegistry_onboardingModal_placeholder",
  "stripeRegistry_onboardingModal_firstNameInput",
  "stripeRegistry_onboardingModal_lastNameInput",
  "stripeRegistry_onboardingModal_continueButton",

  // Stripe Registry - Contribution Modal (give-gift flow)
  "stripeRegistry_contributionModal_pending",
  "stripeRegistry_contributionModal_step1",
  "stripeRegistry_contributionModal_step2",
  "stripeRegistry_contributionModal_step3",
  "stripeRegistry_contributionModal_step4",
  "stripeRegistry_contributionModal_amountChip", // append: _half, _full, _double
  "stripeRegistry_contributionModal_quickOptionChip", // append dollar amount, e.g. _25, _50
  "stripeRegistry_contributionModal_quickOptionChipOther",
  "stripeRegistry_contributionModal_amountOtherInput",
  "stripeRegistry_contributionModal_nextButton",
  "stripeRegistry_contributionModal_nameInput",
  "stripeRegistry_contributionModal_emailInput",
  "stripeRegistry_contributionModal_noteInput",
  "stripeRegistry_contributionModal_doneButton",

  // Stripe Registry - Website Card
  "stripeRegistry_websiteCard",
  "stripeRegistry_websiteCard_image",
  "stripeRegistry_websiteCard_text",
  "stripeRegistry_websiteCard_title",
  "stripeRegistry_websiteCard_progressBar",
  "stripeRegistry_websiteCard_giftedBadge",

  // RSVP - Public Website
  "rsvp_searchNameInput",
  "rsvp_findRsvpButton",
  "rsvp_searchModal_nameInput",
  "rsvp_searchModal_findButton",
  "rsvp_searchModal_selectResult",
  "rsvp_attendingPicker",
  "rsvp_backButton",
  "rsvp_nextButton",
  "rsvp_submitButton",
] as const;

export const selectors = Object.fromEntries(
  selectorKeys.map((key) => [key, key]),
) as Record<(typeof selectorKeys)[number], string>;
